import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';



export const TierOvrdDialog = ({ selectedEntities, closeDialog }) => {

  const rsrc = useRsrc();
  const [tiers, setTiers] = useState();
  const [selectedTier, setSelectedTier] = useState();
  const [selectedOvrdCode, setSelectedOvrdCode] = useState();
  const [selData, setSelData] = useState(null);
  

  useEffect(() => {
    rsrc.data('md', 'TIER_OVRD_REASON_CODE_ENUM_DATA_PLUGIN').then((res) => {
      setSelData(res);
    });
  }, []);



  // Fetch Tiers
  useEffect(() => {
    const rowsReq = {
      replaceParams: {
        progId: selectedEntities[0].progId,
      }
    };
    rsrc.rows('md', 'PROG_TIERS', rowsReq).then(res => {
      setTiers(res);
    });
  }, [])

  const submit = () => {
    // XXX: AH review
    const updatedEntities =  selectedEntities.map(entityObj => {
      return { id: entityObj.id, ovrdTier: selectedTier, tierOvrdReasonCode: selectedOvrdCode, progId: selectedEntities[0].progId}
    });

    rsrc.save('md', 'TIER_RES', updatedEntities, 'progId').then(() => {
      closeDialog();
    });
  }



  return (
    <Dialog onClose={closeDialog} open fullWidth data-test-id="tier-ovrd-dialog">
      <DialogTitle>Override Tier</DialogTitle>
      <DialogContent>
        {tiers && (
          <FormControl fullWidth sx={{ marginBottom: '1rem' }}>
            <InputLabel>Tier</InputLabel>
            <Select
              value={selectedTier}
              onChange={(event) => setSelectedTier(event.target.value)}
              data-test-id="tier-selector">
              {tiers.map(tier => (
                <MenuItem key={tier.tier} value={tier.tier} data-test-id={`select-"${tier.tier}"`}>
                  {tier.tier}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {selData && (
          <FormControl fullWidth sx={{ marginBottom: '1rem' }}>
            <InputLabel>Override Reason Code</InputLabel>
            <Select
              value={selectedOvrdCode}
              onChange={(event) => setSelectedOvrdCode(event.target.value)}
              data-test-id="ovrd-code-selector"
            >
              {Object.entries(selData).map(([name, displayName]) => (
                <MenuItem key={name} value={name} data-test-id={`select-${displayName}`}>
                  {displayName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        
      </DialogContent>

      <DialogActions>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button onClick={submit} data-test-id="sub-upload-button-submit">Submit</Button>
      </DialogActions>
    </Dialog>
  )
}

